import PropTypes from "prop-types"
import SourceShape from "./SourceShape"


const CustomerShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isSoleProprietorship: PropTypes.bool,
  verificationStatus: PropTypes.string.isRequired,
  verificationStep: PropTypes.string,
  identityVerificationFailedReasons: PropTypes.arrayOf(PropTypes.string),
  businessVerificationFailedReasons: PropTypes.arrayOf(PropTypes.string),
  sources: PropTypes.arrayOf(SourceShape),
})

export default CustomerShape
